module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-natural-brushed-4041-panel.e8bb0b39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-natural-brushed-4041-panel.jpg
// module id = 1120
// module chunks = 37